import { useEffect, useMemo, useState } from 'react';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar, Cell, Tooltip } from 'recharts';
import { Breakdown7DaysItem } from 'src/types/bookingFailureLog.type';

const FailureBreakDownBarChart = ({ breakdown7Days }: { breakdown7Days: Breakdown7DaysItem[] }) => {
   const [marginLeft, setMarginLeft] = useState(100);

   const data = useMemo(() => {
      if (!breakdown7Days) return [];

      return (
         breakdown7Days
            // Take the top 3 items with the highest values
            .sort((a, b) => b.percentage - a.percentage)
            .slice(0, 3)
            .map((item, idx: number) => ({
               name: item.type,
               value: item.percentage,
               color: idx === 0 ? '#ff4d4f' : idx === 1 ? '#52c41a' : '#faad14',
            }))
      );
   }, [breakdown7Days]);

   const Label = ({ x, y, payload }: { x: number | string; y: number | string; payload: any }) => {
      return (
         <text x={+x + 5} y={+y + 10} textAnchor="end" dominantBaseline="middle" style={{ fontSize: 14, fontWeight: 600, fill: '#333' }}>
            {payload.value}
         </text>
      );
   };

   useEffect(() => {
      const handleResize = () => {
         const width = window.innerWidth;
         if (width < 1050) setMarginLeft(50);
         else if (width < 1150) setMarginLeft(70);
         else setMarginLeft(100);
      };

      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
   }, []);

   return (
      <ResponsiveContainer height={120} style={{ outline: 'none' }}>
         {data ? (
            <BarChart data={data} layout="vertical" barSize={18} margin={{ left: marginLeft }} style={{ outline: 'none' }}>
               <CartesianGrid strokeDasharray="4 4" />
               <XAxis
                  type="number"
                  ticks={[0, 20, 40, 60, 80]}
                  domain={[0, 80]}
                  tickLine={false}
                  axisLine={false}
                  tick={({ x, y, payload }) => <Label x={+x} y={+y} payload={payload} />}
               />
               <YAxis
                  type="category"
                  dataKey="name"
                  tickLine={false}
                  axisLine={false}
                  tick={({ x, y, payload }) => <Label x={+x - 8} y={+y - 8} payload={payload} />}
               />
               <Tooltip />
               <Bar dataKey="value">
                  {data.map((entry, index) => (
                     <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
               </Bar>
            </BarChart>
         ) : null}
      </ResponsiveContainer>
   );
};
export default FailureBreakDownBarChart;
